import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantToggle, UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { combineLatest, filter, map, take } from 'rxjs';

export const homepageGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return combineLatest([authService.tenant$, authService.currentUser$]).pipe(
    filter(([tenant, user]) => !!tenant && !!user),
    take(1),
    map(([tenant, user]) =>
      tenant.homepageGuideIds?.length > 0
        ? true
        : user?.rules?.every(
              (rule) =>
                ![
                  UserRule.projectAdmin,
                  UserRule.projectEditing,
                  UserRule.projectManagement,
                  UserRule.projectDownloading,
                  UserRule.projectUploading,
                ].includes(rule),
            )
          ? user?.rules?.includes(UserRule.assetViewing)
            ? router.parseUrl('/assets')
            : router.parseUrl('error?code=404')
          : (tenant?.toggles || []).includes(
                TenantToggle.monitoringProjectsOnly,
              )
            ? router.parseUrl('/collections')
            : router.parseUrl('/projects'),
    ),
  );
};
